import * as React from 'react';

const SvgCheckDoubleOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 17 17"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M13.856 6.201a.75.75 0 0 0-1.212-.884l-4.375 6a.75.75 0 1 0 1.212.884zm-3 0a.75.75 0 0 0-1.212-.883L5.78 10.617 3.775 8.652a.75.75 0 0 0-1.05 1.072l2.625 2.571a.75.75 0 0 0 1.131-.094z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgCheckDoubleOutlined;
